//==============================================================
// ForumReplyItem.jsx
//==============================================================

import React from "react";
import { useTranslation } from "react-i18next";

import { getLoggedInUser} from "../../pages/userapp/ServiceUserApp";

import {
    BASE_URL
} from "../../utils/serverContextPath";

import AttachmentViewer from "../../components/common/attachment/AttachmentViewer"

export default function ForumReplyItem({

    reply,
    onEdit,
    onDelete

}) {
 const { t } = useTranslation();


    //--------------------------------------------------
    // Utilisateur connecté
    //--------------------------------------------------

    const currentUser = getLoggedInUser();


    //--------------------------------------------------
    // ADMIN ?
    //--------------------------------------------------

    const isAdmin =

        currentUser &&
        currentUser.role === "ADMIN";


    //--------------------------------------------------
    // Auteur
    //--------------------------------------------------

    const sender = reply?.sender;

    //----------------------------------------------------------
    // Peut modifier ?
    //----------------------------------------------------------

    const canEdit =

        currentUser &&
        sender &&
        currentUser.id === sender.id;

    //----------------------------------------------------------
    // Format date
    //----------------------------------------------------------

    const formatDate = (date) => {

        if (!date) {

            return "";

        }

        return new Date(date).toLocaleDateString(

            "fr-FR",

            {

                day: "2-digit",
                month: "2-digit",
                year: "numeric"

            }

        );

    };

    //----------------------------------------------------
    // Format de la date
    //----------------------------------------------------
const formatDateTime = (dateValue) => {

    if (!dateValue) {

        return "";
    }

    const [datePart, timePart] = dateValue.split(" ");

    const [day, month, year] = datePart.split("/");

    const [hours, minutes, seconds] = timePart.split(":");

    return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;

};

    //----------------------------------------------------------
    // Photo profil
    //----------------------------------------------------------

    const defaultAvatar =
        "https://cdn-icons-png.flaticon.com/512/847/847969.png";

 
    const photoUrl = sender?.photoUrl
        ? `${BASE_URL}userapp/downloadprofile/${sender.id}`
        : defaultAvatar;

    //----------------------------------------------------------
    // {t("common.attachments")}
    //----------------------------------------------------------

    const attachments = [
        {
            fileName: reply?.attachedFile1,
            index: 1
        },

        {
            fileName: reply?.attachedFile2,
            index: 2
        },

        {
            fileName: reply?.attachedFile3,
            index: 3
        },

        {
            fileName: reply?.attachedFile4,
            index: 4
        }

    ].filter(item => item.fileName);


    //----------------------------------------------------------
    // RENDER
    //----------------------------------------------------------

    return (

        <div className="card forum-reply-card shadow-sm mb-3">


            {/*================================================*/}
            {/* HEADER                                         */}
            {/*================================================*/}

            <div className="forum-reply-header p-3">

                <div
                    className="
                    d-flex
                    justify-content-between
                    align-items-start
                    "
                >

                    <div
                        className="
                        d-flex
                        align-items-center
                        "
                    >

                        <img

                            src={photoUrl}

                            alt="avatar"

                            width={55}

                            height={55}

                            className="
                            forum-author-avatar
                            rounded-circle
                            "

                            onError={(e) => {

                                e.target.src =
                                    "/images/avatar.png";

                            }}

                        />

                        <div className="ms-3">

                            <div className="fw-bold">

                                {sender?.fullName ??
                                    "Utilisateur"}

                            </div>

                            <div className="text-muted small">

                                <i className="bi bi-clock me-1"></i>

                                {formatDateTime(reply?.dateMessage)}
                            
                            </div>

                        </div>

                    </div>

{

    isAdmin &&

    <div>

        <button
            className="
            btn
            btn-outline-danger
            btn-sm
            "
            onClick={() => onDelete(reply.id)}
        >

            <i className="bi bi-trash"></i>

        </button>

    </div>

}

                </div>

            </div>


            {/*================================================*/}
            {/* MESSAGE                                        */}
            {/*================================================*/}

            <div className="forum-reply-body p-3">

                <div

                    style={{

                        whiteSpace: "pre-wrap",

                        lineHeight: "1.8"

                    }}

                >

                    {reply?.messageBody}

                </div>

            </div>



            {/*================================================*/}
            {/* PIECES JOINTES                                 */}
            {/*================================================*/}

            {

                attachments.length > 0 && (

                    <div className="px-3 pb-3">

                        <h6 className="mb-3">

                            <i className="bi bi-paperclip me-2"></i>

                            {t("common.attachments")}

                        </h6>


                        {

                            attachments.map((file) => (

                                <AttachmentViewer

                                    key={file.index}

                                    fileName={file.fileName}

                                    url={

                                        `${BASE_URL}` +

                                        `forumreply/downloadfile/` +

                                        `${reply.id}/` +

                                        `${file.index}`

                                    }

                                />

                            ))

                        }

                    </div>

                )

            }


            {/*================================================*/}
            {/* FOOTER                                         */}
            {/*================================================*/}

            <div
                className="
                forum-reply-footer
                border-top
                p-3
                "
            >

                <small className="text-muted">

                    <i className="bi bi-chat-left-text me-2"></i>

                    {t("forum.replyPostedBy")}

                    <strong className="ms-1">

                        {sender?.fullName}

                    </strong>

                </small>

            </div>

        </div>

    );

}